__turbopack_context__.v({
  "actions": "STJobApplication-module__F8gneW__actions",
  "backBtn": "STJobApplication-module__F8gneW__backBtn",
  "cancelBtn": "STJobApplication-module__F8gneW__cancelBtn",
  "formContent": "STJobApplication-module__F8gneW__formContent",
  "jobFileUploadButton": "STJobApplication-module__F8gneW__jobFileUploadButton",
  "jobFileUploader": "STJobApplication-module__F8gneW__jobFileUploader",
  "jobInfoCard": "STJobApplication-module__F8gneW__jobInfoCard",
  "row": "STJobApplication-module__F8gneW__row",
});
